
import { OpcaoEditavel } from '@/dominio/editor/questoes/questao-opcao/opcao/OpcaoEditavel';
import { defineComponent } from 'vue';
import OpcaoVisualizacao from './OpcaoVisualizacao.vue';
import OpcaoEdicao from './OpcaoEdicao.vue';

export default defineComponent({
    name: 'ItemDeOpcao',
    components: {
        OpcaoVisualizacao,
        OpcaoEdicao,
    },
    props: {
        opcao: { type: OpcaoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        editar(opcao: OpcaoEditavel) {
            this.$emit('editar', opcao);
        },
        excluir(opcao: OpcaoEditavel) {
            this.$emit('excluir', opcao);
        },
        descer(opcao: OpcaoEditavel) {
            this.$emit('descer', opcao);
        },
        subir(opcao: OpcaoEditavel) {
            this.$emit('subir', opcao);
        },
    },
    emits: ['editar', 'excluir', 'descer', 'subir'],
});
